import {
    createApi,
    fakeBaseQuery,
} from '@reduxjs/toolkit/query';
import {
    ApiDevice,
    ApiResponse,
    Device,
} from '../features/tradeIn/interfaces/api';
import {
    getApiConfig,
    getQueryParam,
    requestJson,
} from '@vfde-sails/utils';
import {
    TRADEIN_API_CREDENTIALS,
    TRADEIN_INPUT_MAX_LENGTH,
    TRADEIN_INPUT_MIN_LENGTH,
    TRADE_IN_API_QUERY_PARAM,
} from '../features/tradeIn/constants';
import { filterAndFormatDevices } from '../features/tradeIn/helpers/filterAndFormatDevices';
import { miniSerializeError } from '@reduxjs/toolkit';

export const tradeInApi = createApi({
    reducerPath: 'TradeInApi',
    baseQuery: fakeBaseQuery(),
    endpoints: build => ({
        getDevices: build.query<Device[] | null, string>({
            queryFn: async (inputValue, _api) => {
                if (inputValue.length < TRADEIN_INPUT_MIN_LENGTH) {
                    // search input is too short, treat it as default case where data is null
                    return { data: null };
                }

                if (inputValue.length > TRADEIN_INPUT_MAX_LENGTH) {
                    // search input is too long, treat it as device not found
                    return { data: [] };
                }

                const { key, url } = getApiConfig(
                    TRADEIN_API_CREDENTIALS

                );
                const requestUrl = `${url}?${TRADE_IN_API_QUERY_PARAM}=${encodeURIComponent(inputValue)}`;
                const options = {
                    method: 'GET',
                    headers: {
                        // Naming convention doesnt support auth https://github.com/xojs/eslint-config-xo-typescript/issues/44
                        'Authorization': `Basic ${key}`, // eslint-disable-line @typescript-eslint/naming-convention
                        'Content-Type': 'application/json',
                        'vf-country-code': 'DE',
                        'vf-project': 'DLS',
                    },
                };

                try {
                    const response = await requestJson(requestUrl, options) as ApiResponse<ApiDevice[]>;

                    if (!response || response.status !== 200) {
                        return {
                            error: miniSerializeError('Unexpected response'),
                        };
                    }

                    const { body: apiDevices } = response;
                    const devices = filterAndFormatDevices(apiDevices);

                    return { data: devices };
                }
                catch (error) {
                    return {
                        error: miniSerializeError(error),
                    };
                }
            },
        }),
    }),
});

export const {
    getDevices,
} = tradeInApi.endpoints;
